
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/black-friday",
      function () {
        return require("private-next-pages/black-friday.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/black-friday"])
      });
    }
  